import React, { useEffect } from "react";

import {
  Box,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";

import IngredientsForm from "./IngredientsForm";
import Macronutrients from "./Macronutrients";
import { useRecipe } from "../store/RecipeStore";

const RecipeFormTab: React.FC = () => {
  const recipe = useRecipe();

  const { recipeId } = useParams();

  useEffect(() => {
    if (recipeId) recipe.loadRecipe(recipeId);
  }, [recipeId]);

  return (
    <Box display="flex">
      <Box padding={4}>
        <Typography fontSize={20} fontWeight={700}>
          Recipe Details
        </Typography>
        <Box margin={3} />
        <Box>
          <Typography variant="subtitle2">Recipe Name</Typography>
          <Box margin={1} />
          <TextField
            size="small"
            fullWidth
            value={recipe.name}
            onChange={(evt) => recipe.setName(evt.target.value)}
          />
        </Box>
        <Box margin={3} />
        <Box>
          <Typography variant="subtitle2">Preparation Time</Typography>
          <Box margin={1} />
          <TextField
            type="number"
            size="small"
            fullWidth
            value={recipe.hasPreparationTime ? recipe.preparationTime : ""}
            onChange={(evt) => recipe.setPreparationTime(+evt.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">minute(s)</InputAdornment>
              ),
            }}
          />
        </Box>
        <Box margin={3} />
        <Box>
          <Typography variant="subtitle2">Portions per recipe</Typography>
          <Box margin={1} />
          <TextField
            type="number"
            size="small"
            fullWidth
            value={recipe.hasPortionsPerRecipe ? recipe.portionsPerRecipe : ""}
            onChange={(evt) => recipe.setPortionsPerRecipe(+evt.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">serving(s)</InputAdornment>
              ),
            }}
          />
        </Box>
        <Box margin={3} />
        <Box marginBottom={4}>
          <Typography variant="subtitle2">Description</Typography>
          <Box marginBottom={2} />
          <TextField
            size="small"
            rows={4}
            multiline
            fullWidth
            value={recipe.description}
            onChange={(evt) => recipe.setDescription(evt.target.value)}
          />
        </Box>
      </Box>
      <Box>
        <Divider orientation="vertical" />
      </Box>
      <Box flex={1} padding={4}>
        <Macronutrients />
        <Box p={3} />
        <IngredientsForm />
      </Box>
    </Box>
  );
};

export default observer(RecipeFormTab);
